angular.module('gym.bulkImports').controller('ShowBulkImportCtrl', ["$scope", "$rootScope", "$q", "$state", "$timeout", "$window", "loadingAnimation", "EmploymentService", "BulkImports", "ActionCable", "flash", "meta", "bulkImport", function($scope, $rootScope, $q, $state, $timeout, $window, loadingAnimation, EmploymentService, BulkImports, ActionCable, flash, meta, bulkImport) {
  var isFileValid, statuses, unsubscribe;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.perform_bulk_imports) {
    $state.go('gym.dashboard');
  }
  $scope.gym = $rootScope.gym;
  $scope.isMembershipImport = bulkImport.import_type === 'membership';
  $scope.meta = meta;
  $scope.bulkImport = bulkImport;
  $scope.fileData = {};
  statuses = ['uploaded_file', 'file_processing', 'file_invalid', 'ready_for_review', 'queued_for_import', 'importing', 'import_failed', 'import_complete'];
  unsubscribe = ActionCable.create({
    channel: 'BulkImportsChannel',
    uuid: bulkImport.uuid
  }, function(message) {
    return $scope.reloadBulkImport();
  });
  $scope.$on('$destroy', function() {
    return unsubscribe();
  });
  $scope.currentTab = (function() {
    var ref;
    switch (false) {
      case (ref = bulkImport.status) !== 'file_uploaded' && ref !== 'processing_file' && ref !== 'file_invalid' && ref !== 'cancelled':
        return 'upload';
      case bulkImport.status !== 'ready_for_review':
        if ($scope.bulkImport.column_mapping_confirmed) {
          return 'review';
        } else {
          return 'map';
        }
        break;
      default:
        return 'complete';
    }
  })();
  $scope.isTabAvailable = function(tab) {
    var step;
    step = statuses.indexOf($scope.bulkImport.status);
    switch (tab) {
      case 'upload' && $scope.isMembershipImport === false:
        return true;
      case 'map' && $scope.isMembershipImport === false:
        return step > 2;
      case 'review':
        return step > 2 && $scope.bulkImport.column_mapping_confirmed;
      case 'complete':
        return step > 3;
    }
  };
  $scope.setTab = function(tab, force) {
    if (force || $scope.isTabAvailable(tab)) {
      $scope.currentTab = tab;
      return $scope.tabMobileOpen = false;
    } else if ($scope.isMembershipImport && tab !== 'complete') {
      return flash.error = 'This tab is not available for membership imports.';
    } else {
      return flash.info = $scope.bulkImport.status === 'cancelled' ? 'This import has been cancelled.' : 'This tab will be available when your import progresses.';
    }
  };
  $scope.cancel = function() {
    if ($window.confirm('Are you sure?')) {
      loadingAnimation.show();
      return bulkImport.doPUT({}, 'cancel').then(function() {
        return $state.go('gym.bulkImports.list');
      });
    }
  };
  $scope.isLocked = function() {
    var ref;
    return (ref = $scope.bulkImport.status) === 'queued_for_import' || ref === 'importing' || ref === 'import_complete';
  };
  $scope.selectFile = function() {
    angular.element('#importInput').click();
    return true;
  };
  isFileValid = function(file) {
    var names;
    names = file.name.split('.');
    return names.length > 1 && names.pop() === 'csv';
  };
  $scope.$watch('fileData.file', function(file) {
    var reader;
    if (file != null ? file.size : void 0) {
      if (isFileValid(file)) {
        reader = new window.FileReader();
        reader.readAsText(file);
        return reader.onloadend = function() {
          return $timeout(function() {
            var params;
            loadingAnimation.show();
            params = {
              rootObjectName: 'bulk_import',
              file_name: $scope.fileData.file.name,
              file_content: reader.result
            };
            return bulkImport.doPUT(params, 'replace_file').then(function(response) {
              $scope.setTab('upload', true);
              return loadingAnimation.hide();
            });
          });
        };
      } else {
        $scope.fileData.file = void 0;
        return flash.error = "Upload must be in CSV format";
      }
    }
  });
  $scope.confirmMapping = function() {
    $scope.confirmMappingLoading = true;
    return $scope.bulkImport.doPUT({}, 'confirm_mapping').then(function() {
      $scope.confirmMappingLoading = false;
      $scope.reloadBulkImport();
      return $scope.setTab('review', true);
    }, function(response) {
      $scope.confirmMappingLoading = false;
      if (response.data.error_message) {
        return flash.error = response.data.error_message;
      }
    });
  };
  $scope.markAsReviewed = function() {
    var deferred;
    deferred = $q.defer();
    loadingAnimation.show();
    $scope.confirmMappingLoading = true;
    $scope.bulkImport.doPUT({}, 'mark_as_reviewed').then(function() {
      loadingAnimation.hide();
      $scope.setTab('complete', true);
      flash.success = 'File queued for importing';
      return deferred.resolve();
    }, function(response) {
      deferred.reject();
      $scope.setTab('review', true);
      loadingAnimation.hide();
      if (response.data.error_message) {
        return flash.error = response.data.error_message;
      }
    });
    return deferred.promise;
  };
  return $scope.reloadBulkImport = _.debounce(function() {
    return bulkImport.get().then(function(data) {
      return $scope.bulkImport = data;
    });
  }, 500);
}]);
